import React from 'react';
import { object } from 'prop-types';
import { Field } from 'react-final-form';

import Turnstile from './Turnstile';
import css from './SignupSecurity.module.css';

const SignupSecurity = props => {
  const { form, signupError } = props;

  return (
    <div className={css.root}>
      <Field name="website">
        {({ input }) => (
          <div className={css.honeypot} aria-hidden="true">
            <label htmlFor="signup-website">Leave this field empty</label>
            <input
              {...input}
              id="signup-website"
              type="text"
              tabIndex="-1"
              autoComplete="off"
              data-1p-ignore="true"
              data-lpignore="true"
            />
          </div>
        )}
      </Field>
      <Turnstile
        resetKey={signupError}
        onTokenChange={token => form.change('turnstileToken', token)}
      />
    </div>
  );
};

SignupSecurity.defaultProps = {
  signupError: null,
};

SignupSecurity.propTypes = {
  form: object.isRequired,
  signupError: object,
};

export default SignupSecurity;
